
export const featurePaths = {
    Dashboard: "/dashboard",
    Jobs: "/job",
    MyShows: "/myshows",
    ExhibitorDashboard: "/exhibitordashboard",
     Callback: "/callback",

} as const;

export const apiPaths = {} as const;
